export const YearMonths = {
    Jan: "Jan",
    Feb: "Feb",
    Mar: "Mar",
    Apr: "Apr",
    May: "May",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Aug",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Dec",
};

export const NamedTimeRanges = {
    Fiscal_Year: {
        Current: "Current FY",
        Previous: "Previous FY",
        Previous2: "Previous 2 FY",
        _2Ago: "2 FY Ago",
        Next: "Next FY",
        CurrentAndPrevious: "Current and Previous FY",
        CurrentAndPrevious2: "Current and 2 Previous FY",
        CurrentAndNext: "Current and Next FY",
    },
    Fiscal_Quarter: {
        Current: "Current FQ",
        Previous: "Previous FQ",
        Previous2: "Previous 2 FQ",
        _2Ago: "2 FQ Ago",
        Next: "Next FQ",
        CurrentAndPrevious: "Current and Previous FQ",
        CurrentAndPrevious2: "Current and 2 Previous FQ",
        CurrentAndNext: "Current and Next FQ",
    },
    Calendar_Year: {
        Current: "Current CY",
        Previous: "Previous CY",
        Previous2: "Previous 2 CY",
        _2Ago: "2 CY Ago",
        Next: "Next CY",
        CurrentAndPrevious: "Current and Previous CY",
        CurrentAndPrevious2: "Current and 2 Previous CY",
        CurrentAndNext: "Current and Next CY",
    },
    Calendar_Quarter: {
        Current: "Current CQ",
        Previous: "Previous CQ",
        Previous2: "Previous 2 CQ",
        _2Ago: "2 CQ Ago",
        Next: "Next CQ",
        CurrentAndPrevious: "Current and Previous CQ",
        CurrentAndPrevious2: "Current and 2 Previous CQ",
        CurrentAndNext: "Current and Next CQ",
    },
    Calendar_Month: {
        Current: "Current Month",
        Previous: "Previous Month",
        Previous2: "Previous 2 Months",
        _2Ago: "2 Months Ago",
        Next: "Next Month",
        CurrentAndPrevious: "Current and Previous Month",
        CurrentAndPrevious2: "Current and 2 Previous Months",
        CurrentAndNext: "Current and Next Month",
    },
    Calendar_Week: {
        Current: "Current Week",
        Previous: "Previous Week",
        Previous2: "Previous 2 Weeks",
        _2Ago: "2 Weeks Ago",
        Next: "Next Week",
        CurrentAndPrevious: "Current and Previous Week",
        CurrentAndPrevious2: "Current and 2 Previous Weeks",
        CurrentAndNext: "Current and Next Week",
    },
    Calendar_Day: {
        Current: "Today",
        Previous: "Yesterday",
        Previous2: "Previous 2 Days",
        Previous7: "Previous 7 Days",
        Previous14: "Previous 14 Days",
        Last7: "Last 7 Days",
        Last14: "Last 14 Days",
        Last30: "Last 30 Days",
        Last60: "Last 60 Days",
        Last90: "Last 90 Days",
        Last120: "Last 120 Days",
        Last180: "Last 180 Days",
        Last365: "Last 365 Days",
        Next: "Tomorrow",
        Next7: "Next 7 Days",
        Next14: "Next 14 Days",
        Next30: "Next 30 Days",
        Next60: "Next 60 Days",
        Next90: "Next 90 Days",
        Next120: "Next 120 Days",
    },
    Last__Year: YearMonths,
    Current__Year: YearMonths,
    Next__Year: YearMonths,
};
export type NamedTimeRangeGroups = keyof typeof NamedTimeRanges;
export type NamedTimeRange = typeof NamedTimeRanges[NamedTimeRangeGroups][keyof typeof NamedTimeRanges[NamedTimeRangeGroups]];
export interface TimeRangeItem {
    name: string;
    caption: string;
}
export interface TimeRangeGroup {
    label: string;
    items: TimeRangeItem[];
    key: string;
}

export const GetTimeRangeGroups = (): TimeRangeGroup[] => {
    const now = new Date();
    const year = now.getFullYear();
    const ranges = NamedTimeRanges as any;
    const groups: TimeRangeGroup[] = [];
    for (const groupKey in ranges) {
        const timeGroup = ranges[groupKey];
        const groupName = resolveGroupName(groupKey, year);
        const group: TimeRangeGroup = { label: groupName.toString(), key: groupKey, items: [] };
        const suffix = typeof groupName === "number" ? ` ${groupName}` : "";
        if (typeof timeGroup === "object") {
            for (const itemKey in timeGroup) {
                const caption = timeGroup[itemKey];
                group.items.push({ caption: caption + suffix, name: `${groupName}.${itemKey}` });
            }
        }
        groups.push(group);
    }
    return groups;
};
export const GetTimeRangeItems = (): TimeRangeItem[] => {
    const now = new Date();
    const year = now.getFullYear();
    const ranges = NamedTimeRanges as any;
    const result: TimeRangeItem[] = [];
    for (const groupKey in ranges) {
        const timeGroup = ranges[groupKey];
        const groupName = resolveGroupName(groupKey, year);
        const suffix = typeof groupName === "number" ? ` ${groupName}` : "";
        result.push({ caption: "*" + groupName, name: "" });
        if (typeof timeGroup === "object") {
            for (const itemKey in timeGroup) {
                const caption = timeGroup[itemKey];
                result.push({ caption: caption + suffix, name: `${groupName}.${itemKey}` });
            }
        }
    }
    return result;
};
function resolveGroupName(groupKey: string, year: number) {
    switch (groupKey) {
        case "Last__Year":
            return year - 1;
        case "Current__Year":
            return year;
        case "Next__Year":
            return year + 1;
        default:
            return groupKey.replace(/_/g, " ");
    }
}
